// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterLinkColumns_container__16W_K","sending":"FooterLinkColumns_sending__1ATxz"};